"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var MarkEditor_1 = __importDefault(require("../MarkEditor/MarkEditor"));
var LineEditor_1 = __importDefault(require("../LineEditor/LineEditor"));
var FillEditor_1 = __importDefault(require("../FillEditor/FillEditor"));
var TextEditor_1 = __importDefault(require("../TextEditor/TextEditor"));
require("./Editor.css");
require("ol/ol.css");
var _cloneDeep = require('lodash/cloneDeep');
var KindField_1 = __importDefault(require("../Field/KindField/KindField"));
var IconEditor_1 = __importDefault(require("../IconEditor/IconEditor"));
var SymbolizerUtil_1 = __importDefault(require("../../../Util/SymbolizerUtil"));
var LocaleWrapper_1 = require("../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../locale/en_US"));
var RasterEditor_1 = __importDefault(require("../RasterEditor/RasterEditor"));
var DataUtil_1 = __importDefault(require("../../../Util/DataUtil"));
var CompositionContext_1 = require("../../CompositionContext/CompositionContext");
var CompositionUtil_1 = __importDefault(require("../../../Util/CompositionUtil"));
var antd_1 = require("antd");
var Editor = /** @class */ (function (_super) {
    __extends(Editor, _super);
    function Editor(props) {
        var _this = _super.call(this, props) || this;
        _this.onSymbolizerChange = function (symbolizer) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        /**
         * Get the appropriate Editor UI for a certain style.
         *
         * Also handles the customisation of sub-components via CompositionContext.
         */
        _this.getUiFromSymbolizer = function (symbolizer, composition) {
            var _a = _this.props, iconEditorProps = _a.iconEditorProps, iconLibraries = _a.iconLibraries, colorRamps = _a.colorRamps, internalDataDef = _a.internalDataDef;
            switch (symbolizer.kind) {
                case 'Mark':
                    return (CompositionUtil_1.default.handleComposition({
                        composition: composition,
                        path: 'Editor.markEditor',
                        onChange: _this.onSymbolizerChange,
                        onChangeName: 'onSymbolizerChange',
                        propName: 'symbolizer',
                        propValue: symbolizer,
                        defaultElement: (React.createElement(MarkEditor_1.default, { symbolizer: symbolizer }))
                    }));
                case 'Icon':
                    return (CompositionUtil_1.default.handleComposition({
                        composition: composition,
                        path: 'Editor.iconEditor',
                        onChange: _this.onSymbolizerChange,
                        onChangeName: 'onSymbolizerChange',
                        propName: 'symbolizer',
                        propValue: symbolizer,
                        defaultElement: (React.createElement(IconEditor_1.default, __assign({ symbolizer: symbolizer, iconLibraries: iconLibraries }, iconEditorProps)))
                    }));
                case 'Line':
                    return (CompositionUtil_1.default.handleComposition({
                        composition: composition,
                        path: 'Editor.lineEditor',
                        onChange: _this.onSymbolizerChange,
                        onChangeName: 'onSymbolizerChange',
                        propName: 'symbolizer',
                        propValue: symbolizer,
                        defaultElement: (React.createElement(LineEditor_1.default, { symbolizer: symbolizer }))
                    }));
                case 'Fill':
                    return (CompositionUtil_1.default.handleComposition({
                        composition: composition,
                        path: 'Editor.fillEditor',
                        onChange: _this.onSymbolizerChange,
                        onChangeName: 'onSymbolizerChange',
                        propName: 'symbolizer',
                        propValue: symbolizer,
                        defaultElement: (React.createElement(FillEditor_1.default, { symbolizer: symbolizer }))
                    }));
                case 'Text':
                    return (CompositionUtil_1.default.handleComposition({
                        composition: composition,
                        path: 'Editor.textEditor',
                        onChange: _this.onSymbolizerChange,
                        onChangeName: 'onSymbolizerChange',
                        propName: 'symbolizer',
                        propValue: symbolizer,
                        defaultElement: (React.createElement(TextEditor_1.default, { symbolizer: symbolizer, internalDataDef: internalDataDef && DataUtil_1.default.isVector(internalDataDef) ? internalDataDef : undefined }))
                    }));
                case 'Raster':
                    return (CompositionUtil_1.default.handleComposition({
                        composition: composition,
                        path: 'Editor.rasterEditor',
                        onChange: _this.onSymbolizerChange,
                        onChangeName: 'onSymbolizerChange',
                        propName: 'symbolizer',
                        propValue: symbolizer,
                        defaultElement: (React.createElement(RasterEditor_1.default, { symbolizer: symbolizer, colorRamps: colorRamps, internalDataDef: internalDataDef && DataUtil_1.default.isRaster(internalDataDef) ? internalDataDef : undefined }))
                    }));
                default:
                    return _this.props.unknownSymbolizerText;
            }
        };
        _this.onKindFieldChange = function (kind) {
            var newSymbolizer = SymbolizerUtil_1.default.generateSymbolizer(kind);
            _this.onSymbolizerChange(newSymbolizer);
        };
        _this.wrapFormItem = function (locale, element) {
            var formItemLayout = {
                labelCol: { span: 8 },
                wrapperCol: { span: 16 }
            };
            return element == null ? null : (React.createElement(antd_1.Form.Item, __assign({ label: locale }, formItemLayout), element));
        };
        _this.state = {
            symbolizer: SymbolizerUtil_1.default.generateSymbolizer(),
            hasError: false
        };
        return _this;
    }
    Editor.getDerivedStateFromProps = function (nextProps, prevState) {
        return {
            symbolizer: nextProps.symbolizer
        };
    };
    Editor.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({
            hasError: true
        });
    };
    Editor.prototype.render = function () {
        var _this = this;
        if (this.state.hasError) {
            return React.createElement("h1", null, "An error occured in the Symbolizer Editor UI.");
        }
        var locale = this.props.locale;
        var symbolizer = _cloneDeep(this.state.symbolizer);
        return (React.createElement(CompositionContext_1.CompositionContext.Consumer, null, function (composition) { return (React.createElement("div", { className: "gs-symbolizer-editor" },
            _this.wrapFormItem(locale.kindFieldLabel, CompositionUtil_1.default.handleComposition({
                composition: composition,
                path: 'Editor.kindField',
                onChange: _this.onKindFieldChange,
                propName: 'kind',
                propValue: symbolizer.kind,
                defaultElement: React.createElement(KindField_1.default, null)
            })),
            _this.getUiFromSymbolizer(_this.props.symbolizer, composition))); }));
    };
    Editor.componentName = 'SymbolizerEditor';
    Editor.defaultProps = {
        locale: en_US_1.default.GsSymbolizerEditor,
        unknownSymbolizerText: 'Unknown Symbolizer!'
    };
    return Editor;
}(React.Component));
exports.Editor = Editor;
exports.default = LocaleWrapper_1.localize(Editor, Editor.componentName);
//# sourceMappingURL=Editor.js.map